// import { useState, useEffect, useRef } from "react";
// import { useAppContext } from '../context/AppContext';

// const KEYFRAMES = `
//   @keyframes nb-modal-in { 
//     from{opacity:0;transform:scale(.96) translateY(12px)} 
//     to{opacity:1;transform:scale(1) translateY(0)} 
//   }
//   @keyframes nb-pulse { 
//     0%,100%{transform:scale(1);opacity:1}
//     50%{transform:scale(1.1);opacity:0.8}
//   }
//   @keyframes nb-spin {
//     from { transform: rotate(0deg); }
//     to { transform: rotate(360deg); }
//   }
//   @keyframes nb-fade-in {
//     from { opacity: 0; transform: translateY(8px); }
//     to { opacity: 1; transform: translateY(0); }
//   }
//   .nb-modal-in { animation: nb-modal-in .4s cubic-bezier(.16,1,.3,1) both }
//   .nb-pulse { animation: nb-pulse 1.5s ease-in-out infinite }
//   .nb-spin { animation: nb-spin 0.8s linear infinite }
//   .nb-fade-in { animation: nb-fade-in 0.3s ease both }
// `;

// function ModalBg({ isRecording }) {
//     return (
//         <div className="absolute inset-0 overflow-hidden rounded-2xl">
//             <div className="absolute inset-0 rounded-2xl" style={{ background: "white" }} />
//             <div className="absolute inset-0 rounded-2xl" style={{
//                 backgroundImage: "linear-gradient(rgba(96,165,250,.025) 1px,transparent 1px),linear-gradient(90deg,rgba(96,165,250,.025) 1px,transparent 1px)",
//                 backgroundSize: "56px 56px"
//             }} />
//             {isRecording && (
//                 <div className="absolute rounded-full nb-pulse" style={{
//                     width: 300, height: 300, left: "50%", top: "50%",
//                     transform: "translate(-50%, -50%)",
//                     background: "radial-gradient(circle, rgba(239,68,68,.15) 0%, transparent 70%)",
//                     pointerEvents: "none"
//                 }} />
//             )}
//         </div>
//     );
// }

// function RecordButton({ isRecording, onClick, disabled }) {
//     return (
//         <div className="relative flex items-center justify-center">
//             {!isRecording && !disabled && (
//                 <div className="absolute rounded-full" style={{
//                     inset: -8,
//                     border: "2px solid rgba(239,68,68,.3)",
//                     animation: "nb-pulse 1.5s ease-in-out infinite"
//                 }} />
//             )}
//             <button
//                 onClick={onClick}
//                 disabled={disabled}
//                 className="cursor-pointer flex items-center justify-center rounded-full transition-all duration-300 hover:scale-105 active:scale-95"
//                 style={{
//                     width: 80, height: 80,
//                     background: disabled
//                         ? "linear-gradient(135deg, #9ca3af, #6b7280)"
//                         : isRecording
//                             ? "linear-gradient(135deg, #dc2626, #b91c1c)"
//                             : "linear-gradient(135deg, #B03982, #733C86)",
//                     boxShadow: isRecording
//                         ? "0 0 20px rgba(220,38,38,0.5)"
//                         : "0 4px 15px rgba(239,68,68,0.3)",
//                     cursor: disabled ? "not-allowed" : "pointer",
//                     border: "none", zIndex: 1000
//                 }}>
//                 {isRecording ? (
//                     <svg width="32" height="32" viewBox="0 0 24 24" fill="white">
//                         <rect x="6" y="6" width="12" height="12" rx="2" />
//                     </svg>
//                 ) : (
//                     <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
//                         <circle cx="12" cy="12" r="8" />
//                     </svg>
//                 )}
//             </button>
//         </div>
//     );
// }

// // Spinner icon
// function Spinner() {
//     return (
//         <svg className="nb-spin" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
//             <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
//         </svg>
//     );
// }

// // Post-recording form shown after stop
// function RecordingForm({ audioURL, recordingTime, onDiscard, onAnalyze, isAnalyzing }) {

//     const formatTime = (s) => `${Math.floor(s / 60).toString().padStart(2, "0")}:${(s % 60).toString().padStart(2, "0")}`;

//     const handleSubmit = () => {
//         onAnalyze({
//             title: `Meeting ${new Date().toLocaleString()}`,
//             speakerCount: 0,
//             speakerNames: [""].map((n, i) => n.trim() || `Speaker ${i + 1}`),
//             outputLanguage: 'en',
//         });
//     };

//     // Function to download audio as MP3
//     const downloadAudio = () => {
//         if (!audioURL) return;

//         // Create a link element
//         const link = document.createElement('a');
//         link.href = audioURL;
//         link.download = `recording_${new Date().toISOString()}.webm`; // or .mp3 if converted

//         // Trigger download
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//     };

//     // Function to convert and download as MP3 (requires additional library)
//     const downloadAsMp3 = async () => {
//         if (!audioURL) return;

//         try {
//             // Fetch the audio blob
//             const response = await fetch(audioURL);
//             const blob = await response.blob();

//             // Create download link
//             const link = document.createElement('a');
//             link.href = URL.createObjectURL(blob);
//             link.download = `recording_${new Date().toISOString()}.mp3`;
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);

//             // Clean up
//             URL.revokeObjectURL(link.href);
//         } catch (error) {
//             console.error('Error downloading audio:', error);
//         }
//     };

//     return (
//         <div className="nb-fade-in w-full space-y-4 px-6 pb-6 overflow-y-auto" style={{ maxHeight: "calc(85vh - 140px)" }}>
//             {/* Audio preview + duration badge */}
//             <div className="bg-gray-50 rounded-xl p-3 flex flex-col gap-2 mt-4">
//                 <div className="flex items-center justify-between mb-1">
//                     <span className="text-xs font-medium text-gray-500 uppercase tracking-wider">Preview</span>
//                     <span className="text-xs font-mono bg-gray-200 text-gray-600 px-2 py-0.5 rounded-full">
//                         {formatTime(recordingTime)}
//                     </span>
//                 </div>
//                 <div className="flex items-center gap-2">
//                     <audio controls src={audioURL} className="flex-1" style={{ height: 36 }} />
//                     <button
//                         onClick={downloadAsMp3}
//                         className="p-2 rounded-lg bg-blue-500 hover:bg-blue-600 text-white transition-all duration-200"
//                         title="Download Audio"
//                     >
//                         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                             <path d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M12 4v12m-4-4l4 4 4-4" />
//                         </svg>
//                     </button>
//                 </div>
//             </div>

//             {/* Actions */}
//             <div className="flex gap-3 pt-1">
//                 <button
//                     onClick={handleSubmit}
//                     disabled={isAnalyzing}
//                     className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg text-white text-sm font-semibold transition-all duration-200"
//                     style={{
//                         background: isAnalyzing ? "#9ca3af" : "linear-gradient(135deg, #B03982, #733C86)",
//                         cursor: isAnalyzing ? "not-allowed" : "pointer"
//                     }}
//                 >
//                     {isAnalyzing ? <><Spinner /> Submitting…</> : "Submit Recording"}
//                 </button>
//                 <button
//                     onClick={onDiscard}
//                     disabled={isAnalyzing}
//                     className="px-4 py-2.5 rounded-lg border border-gray-200 text-gray-600 text-sm hover:bg-gray-50 transition-all duration-200"
//                 >
//                     Discard
//                 </button>
//             </div>
//         </div>
//     );
// }

// // Result view — renders whatever JSON the Node API returns
// function AnalysisResult({ result, onNewRecording }) {
//     // result is the parsed JSON from the API
//     const renderValue = (val) => {
//         if (Array.isArray(val)) {
//             return (
//                 <ul className="mt-1 space-y-1 pl-3">
//                     {val.map((item, i) => (
//                         <li key={i} className="flex gap-2 text-gray-700 text-sm">
//                             <span className="text-purple-400 mt-0.5">•</span>
//                             <span>{typeof item === "object" ? JSON.stringify(item) : String(item)}</span>
//                         </li>
//                     ))}
//                 </ul>
//             );
//         }
//         if (typeof val === "object" && val !== null) {
//             return <pre className="text-xs bg-gray-100 rounded p-2 mt-1 overflow-x-auto">{JSON.stringify(val, null, 2)}</pre>;
//         }
//         return <p className="text-gray-700 text-sm mt-1 leading-relaxed">{String(val)}</p>;
//     };

//     const entries = typeof result === "object" && result !== null
//         ? Object.entries(result)
//         : [["Response", result]];

//     return (
//         <div className="nb-fade-in flex flex-col gap-4 px-6 pb-6 overflow-y-auto" style={{ maxHeight: "calc(85vh - 140px)" }}>
//             <div className="flex items-center gap-2 mt-4">
//                 <div className="w-2 h-2 rounded-full bg-green-500" />
//                 <span className="text-xs font-semibold text-green-600 uppercase tracking-wider">Analysis Complete</span>
//             </div>

//             <div className="space-y-4">
//                 {entries.map(([key, val]) => (
//                     <div key={key} className="bg-gray-50 rounded-xl p-4">
//                         <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">
//                             {key.replace(/_/g, " ")}
//                         </p>
//                         {renderValue(val)}
//                     </div>
//                 ))}
//             </div>

//             <button
//                 onClick={onNewRecording}
//                 className="w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg border border-gray-200 text-gray-600 text-sm hover:bg-gray-50 transition-all duration-200"
//             >
//                 <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
//                     <circle cx="12" cy="12" r="8" />
//                 </svg>
//                 New Recording
//             </button>
//         </div>
//     );
// }

// // POST audio + metadata to Node API as multipart/form-data
// async function analyzeRecording({ audioBlob, mimeType, duration, title, speakerCount, speakerNames, outputLanguage }) {
//     const ext = mimeType.includes("ogg") ? "ogg" : "webm";
//     const audioFile = new File([audioBlob], `recording.${ext}`, { type: mimeType });

//     const formData = new FormData();
//     formData.append("audio", audioFile);
//     formData.append("duration", String(duration));
//     if (title) formData.append("title", title);
//     if (speakerCount) formData.append("speaker_count", String(speakerCount));
//     if (speakerNames?.length) formData.append("speaker_names", speakerNames.join(","));
//     if (outputLanguage) formData.append("output_language", outputLanguage);

//     const response = await fetch(`https://meeting.srptechs.com/api/meetings/upload`, {
//         method: "POST",
//         body: formData,
//     });

//     if (!response.ok) {
//         const err = await response.json().catch(() => ({}));
//         throw new Error(err?.message || err?.error || `Server error ${response.status}`);
//     }

//     const data = await response.json();
//     return data;
// }

// // Main Modal
// function MeetingRecorderModal({ onClose }) {
//     // phase: "idle" | "recording" | "form" | "analyzing" | "result"
//     const [phase, setPhase] = useState("idle");
//     const [recordingTime, setRecordingTime] = useState(0);
//     const [audioURL, setAudioURL] = useState(null);
//     const [audioBlobRef] = useState({ current: null });
//     const [mimeTypeRef] = useState({ current: "audio/webm" });
//     const [error, setError] = useState(null);
//     const [analysisResult, setAnalysisResult] = useState(null);

//     const mediaRecorderRef = useRef(null);
//     const audioChunksRef = useRef([]);
//     const streamRef = useRef(null);
//     const timerRef = useRef(null);

//     const { fetchMeetings } = useAppContext();

//     const formatTime = (s) => `${Math.floor(s / 60).toString().padStart(2, "0")}:${(s % 60).toString().padStart(2, "0")}`;

//     useEffect(() => {
//         if (phase === "recording") {
//             timerRef.current = setInterval(() => setRecordingTime(p => p + 1), 1000);
//         } else {
//             clearInterval(timerRef.current);
//         }
//         return () => clearInterval(timerRef.current);
//     }, [phase]);

//     useEffect(() => {
//         return () => {
//             if (mediaRecorderRef.current?.state !== "inactive") mediaRecorderRef.current?.stop();
//             streamRef.current?.getTracks().forEach(t => t.stop());
//             clearInterval(timerRef.current);
//         };
//     }, []);

//     const startRecording = async () => {
//         setError(null);
//         try {
//             const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
//             streamRef.current = stream;

//             const mimeType = MediaRecorder.isTypeSupported("audio/webm") ? "audio/webm" : "audio/ogg";
//             mimeTypeRef.current = mimeType;

//             const mediaRecorder = new MediaRecorder(stream, { mimeType });
//             mediaRecorderRef.current = mediaRecorder;
//             audioChunksRef.current = [];

//             mediaRecorder.ondataavailable = e => {
//                 if (e.data.size > 0) audioChunksRef.current.push(e.data);
//             };

//             mediaRecorder.onstop = () => {
//                 if (audioChunksRef.current.length > 0) {
//                     const blob = new Blob(audioChunksRef.current, { type: mimeType });
//                     audioBlobRef.current = blob;
//                     const url = URL.createObjectURL(blob);
//                     setAudioURL(url);
//                     setPhase("form");
//                 }
//                 streamRef.current?.getTracks().forEach(t => t.stop());
//                 streamRef.current = null;
//             };

//             mediaRecorder.start();
//             setRecordingTime(0);
//             setPhase("recording");
//         } catch (err) {
//             if (err.name === "NotAllowedError") setError("Microphone access denied. Please allow microphone access.");
//             else if (err.name === "NotFoundError") setError("No microphone found. Please connect a microphone.");
//             else setError("Could not access microphone. Please try again.");
//         }
//     };

//     const stopRecording = () => {
//         if (mediaRecorderRef.current?.state !== "inactive") {
//             mediaRecorderRef.current.stop();
//         }
//         streamRef.current?.getTracks().forEach(t => t.stop());
//         streamRef.current = null;
//     };

//     const handleRecordClick = () => {
//         if (phase === "recording") stopRecording();
//         else if (phase === "idle") startRecording();
//     };

//     const handleDiscard = () => {
//         if (audioURL) URL.revokeObjectURL(audioURL);
//         audioBlobRef.current = null;
//         setAudioURL(null);
//         setAnalysisResult(null);
//         setError(null);
//         setRecordingTime(0);
//         setPhase("idle");
//     };

//     const handleAnalyze = async ({ title, speakerCount, speakerNames, outputLanguage }) => {
//         if (!audioBlobRef.current) return;
//         setError(null);
//         setPhase("analyzing");
//         try {
//             const result = await analyzeRecording({
//                 audioBlob: audioBlobRef.current,
//                 mimeType: mimeTypeRef.current,
//                 duration: recordingTime,
//                 title,
//                 speakerCount,
//                 speakerNames,
//                 outputLanguage,
//             });
//             setAnalysisResult(result);
//             setPhase("result");
//             fetchMeetings();
//         } catch (err) {
//             setError(`Analysis failed: ${err.message}`);
//             setPhase("form");
//         }
//     };

//     const isRecording = phase === "recording";
//     const showRecordButton = phase === "idle" || phase === "recording";

//     return (
//         <div
//             className="relative flex flex-col overflow-hidden rounded-2xl nb-modal-in"
//             style={{
//                 width: "min(500px, 90vw)",
//                 maxHeight: "85vh",
//                 boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)",
//                 background: "white"
//             }}
//         >
//             <ModalBg isRecording={isRecording} />

//             {/* Header */}
//             <header
//                 className="relative z-10 flex items-center justify-between px-6 py-4 shrink-0"
//                 style={{ borderBottom: "1px solid rgba(0,0,0,.08)" }}
//             >
//                 <h2 className="text-xl font-semibold text-gray-800">Meeting Recorder</h2>
//                 <button
//                     onClick={onClose}
//                     className="flex items-center justify-center w-8 h-8 rounded-full transition-all duration-200 hover:bg-gray-100"
//                 >
//                     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
//                         <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
//                     </svg>
//                 </button>
//             </header>

//             <div className="relative z-10 flex flex-col flex-1 overflow-hidden">
//                 {/* Record phase */}
//                 {showRecordButton && (
//                     <div className="flex-1 flex flex-col items-center justify-center p-6">
//                         {isRecording && (
//                             <div className="text-center mb-8">
//                                 <div className="inline-flex items-center gap-3 bg-red-50 px-5 py-2 rounded-full">
//                                     <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse" />
//                                     <span className="text-red-600 font-semibold">RECORDING</span>
//                                     <span className="text-red-600 font-mono font-semibold">{formatTime(recordingTime)}</span>
//                                 </div>
//                             </div>
//                         )}
//                         <div className="mb-8">
//                             <RecordButton isRecording={isRecording} onClick={handleRecordClick} />
//                         </div>
//                         {!isRecording && (
//                             <p className="text-gray-500 text-center text-sm">
//                                 Click to start recording your meeting
//                             </p>
//                         )}
//                         {isRecording && (
//                             <p className="text-gray-400 text-center text-xs mt-2">
//                                 Click the button again to stop and analyze
//                             </p>
//                         )}
//                         {error && (
//                             <div className="mt-4 px-4 py-2 rounded-lg bg-red-50 border border-red-200">
//                                 <p className="text-red-600 text-sm">{error}</p>
//                             </div>
//                         )}
//                         {!isRecording && (
//                             <div className="mt-6">
//                                 <button onClick={onClose} className="px-6 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 transition-all duration-200 text-sm">
//                                     Close
//                                 </button>
//                             </div>
//                         )}
//                     </div>
//                 )}

//                 {/* Form phase */}
//                 {(phase === "form" || phase === "analyzing") && (
//                     <RecordingForm
//                         audioURL={audioURL}
//                         recordingTime={recordingTime}
//                         onDiscard={handleDiscard}
//                         onAnalyze={handleAnalyze}
//                         isAnalyzing={phase === "analyzing"}
//                     />
//                 )}

//                 {/* Error after analyze */}
//                 {error && phase === "form" && (
//                     <div className="px-6 pb-4">
//                         <div className="px-4 py-2 rounded-lg bg-red-50 border border-red-200">
//                             <p className="text-red-600 text-sm">{error}</p>
//                         </div>
//                     </div>
//                 )}

//                 {/* Result phase */}
//                 {phase === "result" && (
//                     <AnalysisResult result={analysisResult} onNewRecording={handleDiscard} />
//                 )}
//             </div>
//         </div>
//     );
// }

// export default function MeetingRecorder() {
//     const [open, setOpen] = useState(false);

//     useEffect(() => {
//         const tag = document.createElement("style");
//         tag.textContent = KEYFRAMES;
//         document.head.appendChild(tag);
//         return () => document.head.removeChild(tag);
//     }, []);

//     useEffect(() => {
//         document.body.style.overflow = open ? "hidden" : "";
//         return () => { document.body.style.overflow = ""; };
//     }, [open]);

//     return (
//         <>
//             <div className="fixed bottom-5 right-6 z-50">
//                 <button
//                     onClick={() => setOpen(true)}
//                     className="relative w-20 h-20 rounded-full flex items-center justify-center shadow-lg hover:scale-110 active:scale-95 transition-all duration-300"
//                     style={{ background: "linear-gradient(135deg, #B03982, #733C86)" }}
//                 >
//                     <span className="absolute inline-flex h-full w-full rounded-full opacity-30 animate-ping"
//                         style={{ background: "linear-gradient(135deg, #B03982, #733C86)" }} />
//                     <svg width="32" height="32" viewBox="0 0 24 24" fill="white">
//                         <circle cx="12" cy="12" r="8" />
//                     </svg>
//                 </button>
//             </div>
//             {open && (
//                 <div
//                     className="fixed inset-0 z-50 flex items-center justify-center p-4"
//                     style={{ background: "rgba(0,0,0,.7)", backdropFilter: "blur(8px)" }}
//                     onClick={e => { if (e.target === e.currentTarget) setOpen(false); }}
//                 >
//                     <MeetingRecorderModal onClose={() => setOpen(false)} />
//                 </div>
//             )}
//         </>
//     );
// }

import { useState, useEffect, useRef } from "react";
import { useAppContext } from '../context/AppContext';

const KEYFRAMES = `
  @keyframes nb-modal-in { 
    from{opacity:0;transform:scale(.96) translateY(12px)} 
    to{opacity:1;transform:scale(1) translateY(0)} 
  }
  @keyframes nb-pulse { 
    0%,100%{transform:scale(1);opacity:1}
    50%{transform:scale(1.1);opacity:0.8}
  }
  @keyframes nb-spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  @keyframes nb-fade-in {
    from { opacity: 0; transform: translateY(8px); }
    to { opacity: 1; transform: translateY(0); }
  }
  .nb-modal-in { animation: nb-modal-in .4s cubic-bezier(.16,1,.3,1) both }
  .nb-pulse { animation: nb-pulse 1.5s ease-in-out infinite }
  .nb-spin { animation: nb-spin 0.8s linear infinite }
  .nb-fade-in { animation: nb-fade-in 0.3s ease both }
`;

function ModalBg({ isRecording }) {
    return (
        <div className="absolute inset-0 overflow-hidden rounded-2xl">
            <div className="absolute inset-0 rounded-2xl" style={{ background: "white" }} />
            <div className="absolute inset-0 rounded-2xl" style={{
                backgroundImage: "linear-gradient(rgba(96,165,250,.025) 1px,transparent 1px),linear-gradient(90deg,rgba(96,165,250,.025) 1px,transparent 1px)",
                backgroundSize: "56px 56px"
            }} />
            {isRecording && (
                <div className="absolute rounded-full nb-pulse" style={{
                    width: 300, height: 300, left: "50%", top: "50%",
                    transform: "translate(-50%, -50%)",
                    background: "radial-gradient(circle, rgba(239,68,68,.15) 0%, transparent 70%)",
                    pointerEvents: "none"
                }} />
            )}
        </div>
    );
}

function RecordButton({ isRecording, onClick, disabled }) {
    return (
        <div className="relative flex items-center justify-center">
            {!isRecording && !disabled && (
                <div className="absolute rounded-full" style={{
                    inset: -8,
                    border: "2px solid rgba(239,68,68,.3)",
                    animation: "nb-pulse 1.5s ease-in-out infinite"
                }} />
            )}
            <button
                onClick={onClick}
                disabled={disabled}
                className="cursor-pointer flex items-center justify-center rounded-full transition-all duration-300 hover:scale-105 active:scale-95"
                style={{
                    width: 80, height: 80,
                    background: disabled
                        ? "linear-gradient(135deg, #9ca3af, #6b7280)"
                        : isRecording
                            ? "linear-gradient(135deg, #dc2626, #b91c1c)"
                            : "linear-gradient(135deg, #B03982, #733C86)",
                    boxShadow: isRecording
                        ? "0 0 20px rgba(220,38,38,0.5)"
                        : "0 4px 15px rgba(239,68,68,0.3)",
                    cursor: disabled ? "not-allowed" : "pointer",
                    border: "none", zIndex: 1000
                }}>
                {isRecording ? (
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="white">
                        <rect x="6" y="6" width="12" height="12" rx="2" />
                    </svg>
                ) : (
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
                        <circle cx="12" cy="12" r="8" />
                    </svg>
                )}
            </button>
        </div>
    );
}

// Spinner icon
function Spinner() {
    return (
        <svg className="nb-spin" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
        </svg>
    );
}

// Audio import component
function AudioImport({ onAudioImported, isAnalyzing }) {
    const fileInputRef = useRef(null);

    const handleFileSelect = (event) => {
        const file = event.target.files?.[0];
        if (!file) return;

        // Validate file type
        const validTypes = ['audio/mpeg', 'audio/mp3', 'audio/wav', 'audio/ogg', 'audio/webm', 'audio/mp4'];
        if (!validTypes.includes(file.type) && !file.name.match(/\.(mp3|wav|ogg|webm|m4a)$/i)) {
            alert('Please select a valid audio file (MP3, WAV, OGG, WEBM, M4A)');
            return;
        }

        // Validate file size (max 50MB)
        if (file.size > 50 * 1024 * 1024) {
            alert('File size must be less than 50MB');
            return;
        }

        // Create audio URL and pass to parent
        const url = URL.createObjectURL(file);
        onAudioImported({
            blob: file,
            url: url,
            mimeType: file.type,
            duration: null, // Will be extracted from audio element
            fileName: file.name
        });
    };

    const triggerFileInput = () => {
        fileInputRef.current?.click();
    };

    return (
        <div className="flex flex-col items-center gap-3">
            <input
                ref={fileInputRef}
                type="file"
                accept="audio/*,.mp3,.wav,.ogg,.webm,.m4a"
                onChange={handleFileSelect}
                className="hidden"
            />
            <button
                onClick={triggerFileInput}
                disabled={isAnalyzing}
                className="flex items-center gap-2 px-4 py-2 rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 hover:bg-gray-100 transition-all duration-200 text-gray-600 text-sm font-medium"
                style={{ cursor: isAnalyzing ? "not-allowed" : "pointer" }}
            >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 4v16M4 12h16" />
                    <path d="M4 16l4-4-4-4M20 16l-4-4 4-4" />
                </svg>
                Import Audio File (MP3, WAV, etc.)
            </button>
        </div>
    );
}

// Post-recording form shown after stop/import
function RecordingForm({ audioURL, recordingTime, onDiscard, onAnalyze, isAnalyzing, onImportMode, isImportMode }) {
    const [audioDuration, setAudioDuration] = useState(recordingTime);
    const audioRef = useRef(null);

    const formatTime = (s) => `${Math.floor(s / 60).toString().padStart(2, "0")}:${(s % 60).toString().padStart(2, "0")}`;

    // Get audio duration for imported files
    useEffect(() => {
        if (isImportMode && audioURL && audioRef.current) {
            const audio = audioRef.current;
            const handleLoadedMetadata = () => {
                setAudioDuration(Math.floor(audio.duration));
            };
            audio.addEventListener('loadedmetadata', handleLoadedMetadata);
            return () => audio.removeEventListener('loadedmetadata', handleLoadedMetadata);
        }
    }, [audioURL, isImportMode]);

    const displayDuration = isImportMode ? audioDuration : recordingTime;

    const handleSubmit = () => {
        onAnalyze({
            title: `Meeting ${new Date().toLocaleString()}`,
            speakerCount: 0,
            speakerNames: [""].map((n, i) => n.trim() || `Speaker ${i + 1}`),
            outputLanguage: 'en',
        });
    };

    const downloadAsMp3 = async () => {
        if (!audioURL) return;
        try {
            const response = await fetch(audioURL);
            const blob = await response.blob();
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `recording_${new Date().toISOString()}.mp3`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
        } catch (error) {
            console.error('Error downloading audio:', error);
        }
    };

    return (
        <div className="nb-fade-in w-full space-y-4 px-6 pb-6 overflow-y-auto" style={{ maxHeight: "calc(85vh - 140px)" }}>
            {isImportMode && (
                <audio ref={audioRef} src={audioURL} className="hidden" />
            )}

            {/* Audio preview + duration badge */}
            <div className="bg-gray-50 rounded-xl p-3 flex flex-col gap-2 mt-4">
                <div className="flex items-center justify-between mb-1">
                    <span className="text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {isImportMode ? 'Imported Audio Preview' : 'Recording Preview'}
                    </span>
                    <span className="text-xs font-mono bg-gray-200 text-gray-600 px-2 py-0.5 rounded-full">
                        {formatTime(displayDuration)}
                    </span>
                </div>
                <div className="flex items-center gap-2">
                    <audio controls src={audioURL} className="flex-1" style={{ height: 36 }} />
                    <button
                        onClick={downloadAsMp3}
                        className="p-2 rounded-lg bg-blue-500 hover:bg-blue-600 text-white transition-all duration-200"
                        title="Download Audio"
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M12 4v12m-4-4l4 4 4-4" />
                        </svg>
                    </button>
                </div>
            </div>

            {/* Actions */}
            <div className="flex gap-3 pt-1">
                <button
                    onClick={handleSubmit}
                    disabled={isAnalyzing}
                    className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg text-white text-sm font-semibold transition-all duration-200"
                    style={{
                        background: isAnalyzing ? "#9ca3af" : "linear-gradient(135deg, #B03982, #733C86)",
                        cursor: isAnalyzing ? "not-allowed" : "pointer"
                    }}
                >
                    {isAnalyzing ? <><Spinner /> Submitting…</> : "Submit Recording"}
                </button>
                <button
                    onClick={onDiscard}
                    disabled={isAnalyzing}
                    className="px-4 py-2.5 rounded-lg border border-gray-200 text-gray-600 text-sm hover:bg-gray-50 transition-all duration-200"
                >
                    Discard
                </button>
            </div>
        </div>
    );
}

// Result view — renders whatever the Node API returns
function AnalysisResult({ result, onNewRecording }) {
    const renderValue = (val) => {
        if (Array.isArray(val)) {
            return (
                <ul className="mt-1 space-y-1 pl-3">
                    {val.map((item, i) => (
                        <li key={i} className="flex gap-2 text-gray-700 text-sm">
                            <span className="text-purple-400 mt-0.5">•</span>
                            <span>{typeof item === "object" ? JSON.stringify(item) : String(item)}</span>
                        </li>
                    ))}
                </ul>
            );
        }
        if (typeof val === "object" && val !== null) {
            return <pre className="text-xs bg-gray-100 rounded p-2 mt-1 overflow-x-auto">{JSON.stringify(val, null, 2)}</pre>;
        }
        return <p className="text-gray-700 text-sm mt-1 leading-relaxed">{String(val)}</p>;
    };

    const entries = typeof result === "object" && result !== null
        ? Object.entries(result)
        : [["Response", result]];

    return (
        <div className="nb-fade-in flex flex-col gap-4 px-6 pb-6 overflow-y-auto" style={{ maxHeight: "calc(85vh - 140px)" }}>
            <div className="flex items-center gap-2 mt-4">
                <div className="w-2 h-2 rounded-full bg-green-500" />
                <span className="text-xs font-semibold text-green-600 uppercase tracking-wider">Analysis Complete</span>
            </div>

            <div className="space-y-4">
                {entries.map(([key, val]) => (
                    <div key={key} className="bg-gray-50 rounded-xl p-4">
                        <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">
                            {key.replace(/_/g, " ")}
                        </p>
                        {renderValue(val)}
                    </div>
                ))}
            </div>

            <button
                onClick={onNewRecording}
                className="w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg border border-gray-200 text-gray-600 text-sm hover:bg-gray-50 transition-all duration-200"
            >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <circle cx="12" cy="12" r="8" />
                </svg>
                New Recording
            </button>
        </div>
    );
}

// POST audio + metadata to Node API as multipart/form-data
async function analyzeRecording({ audioBlob, mimeType, duration, title, speakerCount, speakerNames, outputLanguage }) {

    const ext = mimeType.includes("mpeg") ? "mp3" :
        mimeType.includes("wav") ? "wav" :
            mimeType.includes("ogg") ? "ogg" : "webm";
    const audioFile = new File([audioBlob], `recording.${ext}`, { type: mimeType });

    const formData = new FormData();
    formData.append("audio", audioFile);
    formData.append("duration", String(duration));
    if (title) formData.append("title", title);
    if (speakerCount) formData.append("speaker_count", String(speakerCount));
    if (speakerNames?.length) formData.append("speaker_names", speakerNames.join(","));
    if (outputLanguage) formData.append("output_language", outputLanguage);

    const response = await fetch(`https://meeting.srptechs.com/api/meetings/upload`, {
        method: "POST",
        body: formData,
    });

    if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err?.message || err?.error || `Server error ${response.status}`);
    }

    const data = await response.json();
    return data;
}

// Main Modal
function MeetingRecorderModal({ onClose }) {
    // phase: "idle" | "recording" | "form" | "analyzing" | "result"
    const [phase, setPhase] = useState("idle");
    const [recordingTime, setRecordingTime] = useState(0);
    const [audioURL, setAudioURL] = useState(null);
    const [audioBlobRef] = useState({ current: null });
    const [mimeTypeRef] = useState({ current: "audio/webm" });
    const [error, setError] = useState(null);
    const [analysisResult, setAnalysisResult] = useState(null);
    const [isImportMode, setIsImportMode] = useState(false);

    const mediaRecorderRef = useRef(null);
    const audioChunksRef = useRef([]);
    const streamRef = useRef(null);
    const timerRef = useRef(null);

    const { fetchMeetings } = useAppContext();

    const formatTime = (s) => `${Math.floor(s / 60).toString().padStart(2, "0")}:${(s % 60).toString().padStart(2, "0")}`;

    useEffect(() => {
        if (phase === "recording") {
            timerRef.current = setInterval(() => setRecordingTime(p => p + 1), 1000);
        } else {
            clearInterval(timerRef.current);
        }
        return () => clearInterval(timerRef.current);
    }, [phase]);

    useEffect(() => {
        return () => {
            if (mediaRecorderRef.current?.state !== "inactive") mediaRecorderRef.current?.stop();
            streamRef.current?.getTracks().forEach(t => t.stop());
            clearInterval(timerRef.current);
        };
    }, []);

    const startRecording = async () => {
        setError(null);
        setIsImportMode(false);
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            streamRef.current = stream;

            const mimeType = MediaRecorder.isTypeSupported("audio/webm") ? "audio/webm" : "audio/ogg";
            mimeTypeRef.current = mimeType;

            const mediaRecorder = new MediaRecorder(stream, { mimeType });
            mediaRecorderRef.current = mediaRecorder;
            audioChunksRef.current = [];

            mediaRecorder.ondataavailable = e => {
                if (e.data.size > 0) audioChunksRef.current.push(e.data);
            };

            mediaRecorder.onstop = () => {
                if (audioChunksRef.current.length > 0) {
                    const blob = new Blob(audioChunksRef.current, { type: mimeType });
                    audioBlobRef.current = blob;
                    const url = URL.createObjectURL(blob);
                    setAudioURL(url);
                    setPhase("form");
                }
                streamRef.current?.getTracks().forEach(t => t.stop());
                streamRef.current = null;
            };

            mediaRecorder.start();
            setRecordingTime(0);
            setPhase("recording");
        } catch (err) {
            if (err.name === "NotAllowedError") setError("Microphone access denied. Please allow microphone access.");
            else if (err.name === "NotFoundError") setError("No microphone found. Please connect a microphone.");
            else setError("Could not access microphone. Please try again.");
        }
    };

    const stopRecording = () => {
        if (mediaRecorderRef.current?.state !== "inactive") {
            mediaRecorderRef.current.stop();
        }
        streamRef.current?.getTracks().forEach(t => t.stop());
        streamRef.current = null;
    };

    const handleRecordClick = () => {
        if (phase === "recording") stopRecording();
        else if (phase === "idle") startRecording();
    };

    // Add this function to get audio duration from imported file
    const getAudioDuration = (file) => {
        return new Promise((resolve) => {
            const audio = new Audio();
            const url = URL.createObjectURL(file);
            audio.addEventListener('loadedmetadata', () => {
                URL.revokeObjectURL(url);
                resolve(Math.floor(audio.duration));
            });
            audio.addEventListener('error', () => {
                URL.revokeObjectURL(url);
                resolve(0);
            });
            audio.src = url;
        });
    };

    const handleAudioImported = async ({ blob, url, mimeType, fileName }) => {
        const duration = await getAudioDuration(blob);
        audioBlobRef.current = blob;
        mimeTypeRef.current = mimeType;
        setAudioURL(url);
        setRecordingTime(duration); // Set the actual duration
        setIsImportMode(true);
        setPhase("form");
    };

    const handleDiscard = () => {
        if (audioURL) URL.revokeObjectURL(audioURL);
        audioBlobRef.current = null;
        setAudioURL(null);
        setAnalysisResult(null);
        setError(null);
        setRecordingTime(0);
        setIsImportMode(false);
        setPhase("idle");
    };

    const handleAnalyze = async ({ title, speakerCount, speakerNames, outputLanguage }) => {
        if (!audioBlobRef.current) return;
        setError(null);
        setPhase("analyzing");
        try {
            const result = await analyzeRecording({
                audioBlob: audioBlobRef.current,
                mimeType: mimeTypeRef.current,
                duration: recordingTime,
                title,
                speakerCount,
                speakerNames,
                outputLanguage,
            });
            setAnalysisResult(result);
            setPhase("result");
            fetchMeetings();
        } catch (err) {
            setError(`Analysis failed: ${err.message}`);
            setPhase("form");
        }
    };

    const isRecording = phase === "recording";
    const showRecordButton = phase === "idle";

    return (
        <div
            className="relative flex flex-col overflow-hidden rounded-2xl nb-modal-in"
            style={{
                width: "min(500px, 90vw)",
                maxHeight: "85vh",
                boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)",
                background: "white"
            }}
        >
            <ModalBg isRecording={isRecording} />

            {/* Header */}
            <header
                className="relative z-10 flex items-center justify-between px-6 py-4 shrink-0"
                style={{ borderBottom: "1px solid rgba(0,0,0,.08)" }}
            >
                <h2 className="text-xl font-semibold text-gray-800">Meeting Recorder</h2>
                <button
                    onClick={onClose}
                    className="flex items-center justify-center w-8 h-8 rounded-full transition-all duration-200 hover:bg-gray-100"
                >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                        <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                </button>
            </header>

            <div className="relative z-10 flex flex-col flex-1 overflow-hidden">
                {/* Record phase - show both record button and import option */}
                {showRecordButton && (
                    <div className="flex-1 flex flex-col items-center justify-center p-6 gap-6">
                        <div className="text-center mb-4">
                            <h3 className="text-lg font-semibold text-gray-700 mb-2">Start New Recording</h3>
                            <p className="text-gray-500 text-sm">Use your microphone to record a meeting</p>
                        </div>

                        <RecordButton isRecording={isRecording} onClick={handleRecordClick} />

                        <div className="relative w-full my-2">
                            <div className="absolute inset-0 flex items-center">
                                <div className="w-full border-t border-gray-200"></div>
                            </div>
                            <div className="relative flex justify-center text-xs">
                                <span className="px-2 bg-white text-gray-400">OR</span>
                            </div>
                        </div>

                        <AudioImport onAudioImported={handleAudioImported} isAnalyzing={phase === "analyzing"} />

                        {error && (
                            <div className="mt-4 px-4 py-2 rounded-lg bg-red-50 border border-red-200 w-full">
                                <p className="text-red-600 text-sm">{error}</p>
                            </div>
                        )}

                        <div className="mt-4">
                            <button onClick={onClose} className="px-6 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 transition-all duration-200 text-sm">
                                Close
                            </button>
                        </div>
                    </div>
                )}

                {/* Recording in progress view */}
                {phase === "recording" && (
                    <div className="flex-1 flex flex-col items-center justify-center p-6">
                        <div className="text-center mb-8">
                            <div className="inline-flex items-center gap-3 bg-red-50 px-5 py-2 rounded-full">
                                <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse" />
                                <span className="text-red-600 font-semibold">RECORDING</span>
                                <span className="text-red-600 font-mono font-semibold">{formatTime(recordingTime)}</span>
                            </div>
                        </div>
                        <div className="mb-8">
                            <RecordButton isRecording={true} onClick={handleRecordClick} />
                        </div>
                        <p className="text-gray-400 text-center text-xs mt-2">
                            Click the button again to stop and analyze
                        </p>
                    </div>
                )}

                {/* Form phase */}
                {(phase === "form" || phase === "analyzing") && (
                    <RecordingForm
                        audioURL={audioURL}
                        recordingTime={recordingTime}
                        onDiscard={handleDiscard}
                        onAnalyze={handleAnalyze}
                        isAnalyzing={phase === "analyzing"}
                        isImportMode={isImportMode}
                    />
                )}

                {/* Error after analyze */}
                {error && phase === "form" && (
                    <div className="px-6 pb-4">
                        <div className="px-4 py-2 rounded-lg bg-red-50 border border-red-200">
                            <p className="text-red-600 text-sm">{error}</p>
                        </div>
                    </div>
                )}

                {/* Result phase */}
                {phase === "result" && (
                    <AnalysisResult result={analysisResult} onNewRecording={handleDiscard} />
                )}
            </div>
        </div>
    );
}

export default function MeetingRecorder() {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const tag = document.createElement("style");
        tag.textContent = KEYFRAMES;
        document.head.appendChild(tag);
        return () => document.head.removeChild(tag);
    }, []);

    useEffect(() => {
        document.body.style.overflow = open ? "hidden" : "";
        return () => { document.body.style.overflow = ""; };
    }, [open]);

    return (
        <>
            <div className="fixed bottom-5 right-6 z-50">
                <button
                    onClick={() => setOpen(true)}
                    className="relative w-20 h-20 rounded-full flex items-center justify-center shadow-lg hover:scale-110 active:scale-95 transition-all duration-300"
                    style={{ background: "linear-gradient(135deg, #B03982, #733C86)" }}
                >
                    <span className="absolute inline-flex h-full w-full rounded-full opacity-30 animate-ping"
                        style={{ background: "linear-gradient(135deg, #B03982, #733C86)" }} />
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="white">
                        <circle cx="12" cy="12" r="8" />
                    </svg>
                </button>
            </div>
            {open && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center p-4"
                    style={{ background: "rgba(0,0,0,.7)", backdropFilter: "blur(8px)" }}
                    onClick={e => { if (e.target === e.currentTarget) setOpen(false); }}
                >
                    <MeetingRecorderModal onClose={() => setOpen(false)} />
                </div>
            )}
        </>
    );
}